<template>
  <div class="payroll-tabs-bar">
    <div class="payroll-tabs">

      <router-link
        v-if="permission.view_payroll == 1"
        :to="$url('/manage-departments')"
        class="payroll-tab"
        :class="isActive(['Manage Department']) ? 'payroll-tab--active' : ''"
      >
        <font-awesome-icon icon="chart-pie" class="tab-icon" />
        Departments
      </router-link>

      <router-link
        v-if="permission.view_payroll == 1"
        :to="$url('/manage-units')"
        class="payroll-tab"
        :class="isActive(['Manage Department Units']) ? 'payroll-tab--active' : ''"
      >
        <font-awesome-icon icon="calendar-alt" class="tab-icon" />
        Units
      </router-link>

      <router-link
        v-if="permission.view_payroll == 1"
        :to="$url('/manage-positions')"
        class="payroll-tab"
        :class="isActive(['Manage Positions']) ? 'payroll-tab--active' : ''"
      >
        <font-awesome-icon icon="calendar-alt" class="tab-icon" />
        Positions
      </router-link>

      <router-link
        v-if="permission.view_payroll == 1"
        :to="$url('/manage-paygrade')"
        class="payroll-tab"
        :class="isActive(['Manage Paygrade','Paygrade Detail']) ? 'payroll-tab--active' : ''"
      >
        <font-awesome-icon icon="chart-pie" class="tab-icon" />
        Paygrade
      </router-link>

      <router-link
        v-if="permission.view_payroll == 1"
        :to="$url('/salary-components')"
        class="payroll-tab"
        :class="isActive(['Salary Components']) ? 'payroll-tab--active' : ''"
      >
        <font-awesome-icon icon="calendar-alt" class="tab-icon" />
        Salary Components
      </router-link>

      <router-link
        v-if="permission.process_payroll == 1"
        :to="$url('/payroll/statutory-deductions')"
        class="payroll-tab"
        :class="isActive(['Payroll Statutory Deduction']) ? 'payroll-tab--active' : ''"
      >
        <font-awesome-icon icon="minus-circle" class="tab-icon" />
        Statutory Deductions
      </router-link>

    </div>
  </div>
</template>

<script>
import { computed } from '@vue/runtime-core';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

export default {
  setup() {
    const store      = useStore();
    const router     = useRouter();
    const permission = computed(() => store.state.getCurrentUserPermission);
    const isActive   = (names) => names.includes(router.currentRoute.value.name);
    return { permission, isActive };
  },
};
</script>

<style scoped>
.payroll-tabs-bar {
  background: #fff;
  border-bottom: 1px solid #e4eaf2;
  padding: 0 20px;
  margin-bottom: 20px;
}

.payroll-tabs {
  display: flex;
  align-items: center;
  gap: 2px;
  overflow-x: auto;
  scrollbar-width: none;
}
.payroll-tabs::-webkit-scrollbar { display: none; }

.payroll-tab {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 13px 16px;
  font-size: 13.5px;
  font-weight: 500;
  color: #7a90b0;
  text-decoration: none;
  border-bottom: 2px solid transparent;
  white-space: nowrap;
  transition: color 0.15s, border-color 0.15s;
  margin-bottom: -1px;
  cursor: pointer;
}
.payroll-tab:hover { color: #004AAD; text-decoration: none; }

.payroll-tab--active {
  color: #004AAD !important;
  border-bottom-color: #004AAD !important;
  font-weight: 600;
}

.tab-icon { font-size: 13px; opacity: 0.85; }

@media (max-width: 576px) {
  .payroll-tabs-bar { padding: 0 12px; }
  .payroll-tab      { padding: 11px 12px; font-size: 13px; gap: 5px; }
}
</style>